<template>
	<!-- default: карточка -->
	<div v-if="variant === 'default'" class="welcome-message">
		<p class="welcome-message-title">{{ strings.defaultTitle }}</p>
		<p class="welcome-message-description">{{ strings.defaultDescription }}</p>
	</div>

	<!-- attached / imageEdit: мусташи ВПЛОТНУЮ к иконке — не добавляй переносов/пробелов вокруг них -->
	<p v-else-if="variant === 'attached' || variant === 'imageEdit'" class="welcome-message-attached">
		{{ strings.attachedPrefix }}<svg-icon name="attachedFile" :size="24" />{{ attachedSuffix }}
	</p>

	<!-- search -->
	<div v-else-if="variant === 'search'" class="welcome-message-search">
		<p>{{ strings.searchLine1 }}</p>
		<p>{{ strings.searchLine2 }}</p>
	</div>

	<!-- music / song -->
	<div
		v-else-if="variant === 'music' || variant === 'song'"
		:class="variant === 'song' ? 'welcome-message-song' : 'welcome-message-music'"
	>
		<img :src="mediaIcon" :alt="variant === 'song' ? 'song icon' : 'music icon'" class="welcome-message-icon" />
		<p>{{ variant === 'song' ? strings.song : strings.music }}</p>
	</div>

	<!-- secret -->
	<div v-else-if="variant === 'secret'" class="welcome-message-secret">
		<svg-icon v-if="!isMts" name="secret" :size="24" />
		<img v-else src="@/resources/icons/mts/secret_mts.svg" alt="" class="welcome-message-secret-icon" />
		<p>{{ strings.secret }}</p>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SvgIcon from '@/components/SvgIcon.vue'
import AppConfig from '@/config'
import {
	welcomeStrings as strings,
	welcomeMediaIcon as mediaIcon,
	type WelcomeVariant
} from '@/constants/welcomeMessages'

const props = withDefaults(defineProps<{ variant?: WelcomeVariant }>(), { variant: 'default' })

const isMts = AppConfig.isMts

const attachedSuffix = computed(() =>
	props.variant === 'imageEdit' ? strings.attachedImageSuffix : strings.attachedDocsSuffix
)
</script>

<style lang="scss" scoped>
.welcome-message {
	background-color: var(--background-primary);
	border-radius: var(--radius-md);
	padding: 24px;
	text-align: center;
	width: 262px;
	margin: 0 auto;
	margin-bottom: 24px;
	&-title {
		font: var(--font-heading);
		margin-bottom: 8px;
	}
	&-description {
		font: var(--font-body-small);
	}
}

// attached / imageEdit (из WelcomeMessageAttached.vue / WelcomeMessageImageEdit.vue — стили идентичны)
.welcome-message-attached {
	text-align: center;
	color: var(--text-secondary);
	margin-bottom: 16px;
	font: var(--font-body);
	& svg {
		color: var(--icon-action);
	}
}
// search (из WelcomeMessageSearch.vue) — порядок объявлений сохранён (margin перебивает margin-bottom)
.welcome-message-search {
	text-align: center;
	color: var(--text-secondary);
	margin-bottom: 16px;
	font: var(--font-body);
	max-width: 307px;
	margin: 0 auto;
}

// music / song (из WelcomeMessageMusic.vue / WelcomeMessageSong.vue — стили идентичны)
.welcome-message-music,
.welcome-message-song {
	text-align: center;
	color: var(--text-secondary);
	display: block;
	font: var(--font-body);
	max-width: 307px;
	margin: 0 auto;
	margin-bottom: 12px;
}

// secret (из WelcomeMessageSecret.vue)
.welcome-message-secret {
	text-align: center;
	color: var(--text-secondary);
	margin-bottom: 16px;
	font: var(--font-body);
	&-icon {
		margin-bottom: 8px;
	}
}
</style>
